import React, { useState } from 'react';
import './clickbitgraphics.scss';
// import Pagination from './partials/Pagination/Pagination';
import Tabs from '../ClickGraphicsActivities/partials/Tabs/Tabs';
import Button from '../../partials/Button';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';
import Instructions from '../../partials/Instructions/Instructions';

const ClickGraphicsActivities = props => {
  const data = props.data;
  console.log(props, "DKDK123123");

  const [source, setSource] = useState(() => {
    return {
      ...data
    }
  });
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(0);
  const [title, setTitle] = useState(null)
  const [instructions, setInstructions] = useState(null)

  const nextTab = () => {
    debugger;
    let newData = source;

    if (tab < newData.tabs.length - 1) {
      newData.tabs[tab].completed = true;
      newData.tabs[tab].active = false;
      newData.tabs[tab + 1].active = true;
      newData.tabs[tab + 1].locked = false;

      setSource({
        ...source,
        tabs: newData.tabs
      });
      setTab(tab + 1);
    } else {
      props.onComplete()
    }

  }

  const changeTab = (tab) => {
    if (source.tabs[tab].locked) {
      return;
    }
    setTab(tab);
  };

  const changePage = (page) => setPage(page);

  const prevPage = () => setPage(page - 1);

  const nextPage = () => setPage(page + 1);

  const tabTitle = (titleContent) => setTitle(titleContent);

  const tabInstructions = (instructionsContent) => {
    setInstructions(instructionsContent);
    console.log("INSTRUCTIONS", instructionsContent)
  };

  const changeActionVisibility = (tab, section, action) => {

    let newData = source;
    let actions = newData.tabs[tab].sections[section].actions;
    // First we hide all other actions
    actions.forEach((item, index) => {
      if (index !== action) {
        item.active = false;
      } else {
        item.active = !item.active;
      }
    });

    setSource({
      ...source,
      tabs: newData.tabs
    });
  }

  // This function is for retry the whole interaction from the beggining
  const retryQuiz = () => {
    setSource({
      ...source,
      tabs: data.tabs
    });
  }

  return (
    <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <Instructions body={instructions != null ? instructions : ""} />
      <span className="title_font">{title}</span>
      <div className="clickbit_graphics">
        <div className="back-btn-container">
          <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>
        <Tabs
          data={source}
          page={page}
          currentTab={tab}
          nextTab={nextTab}
          changeTab={changeTab}
          prevPage={prevPage}
          nextPage={nextPage}
          changePage={changePage}
          changeActionVisibility={changeActionVisibility}
          retryQuiz={retryQuiz}
          onSetTitle ={tabTitle}
          onSetInstructions={tabInstructions}
          onComplete={props.onComplete}
        />
      </div>
    </InteractionContainer>
  );
}

export default ClickGraphicsActivities;